// 增加一下Promise判断
if (!Promise || typeof Promise.prototype.then !== 'function') {
    throw new Error('@ks/general-sso requires Promise polyfill');
}

export * from './services/index';
export * from './services/saveToken';
